import styled from 'styled-components';

import Color from '../../styles/color';

export type Theme = 'SUCCESS' | 'NORMAL' | 'MINIMAL' | 'LINK' | 'LINK_PRIMARY';

function getBackgroundColorByType(theme: Theme) {
  const options = {
    SUCCESS: Color.success,
    NORMAL: Color.primary,
    MINIMAL: 'transparent',
    LINK: 'transparent',
    LINK_PRIMARY: 'transparent',
  };
  return options[theme];
}

export function getFontColorByType(theme: Theme) {
  const options = {
    SUCCESS: Color.white,
    NORMAL: Color.white,
    MINIMAL: Color.primary,
    LINK: Color.neutral90,
    LINK_PRIMARY: Color.primary,
  };
  return options[theme];
}

export function getWidthByType(theme: Theme) {
  const options = {
    SUCCESS: '100%',
    NORMAL: '100%',
    MINIMAL: '100%',
    LINK: 'auto',
    LINK_PRIMARY: 'auto',
  };
  return options[theme];
}

export function getPaddingByType(theme: Theme) {
  const options = {
    SUCCESS: '0',
    NORMAL: '0',
    MINIMAL: '0',
    LINK: '8px',
    LINK_PRIMARY: '8px',
  };
  return options[theme];
}

function getBorderByType(theme: Theme) {
  const options = {
    SUCCESS: '',
    NORMAL: '',
    MINIMAL: `border:1px solid ${Color.primary};`,
    LINK: '',
    LINK_PRIMARY: '',
  };
  return options[theme];
}

interface ButtonProps {
  theme: Theme;
  marginTop: number;
}

export const ButtonContainer = styled.button<ButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: ${p => getWidthByType(p.theme)};
  height: 48px;
  border-radius: 8px;
  border: none;
  background-color: ${p => getBackgroundColorByType(p.theme)};
  color: ${p => getFontColorByType(p.theme)};
  ${p => getBorderByType(p.theme)}
  font-size: 16px;
  text-decoration: none;
  padding: ${p => getPaddingByType(p.theme)};
  transition: all 300ms ease;
  margin-top: ${p => p.marginTop}px;

  &:hover {
    opacity: 0.8;
  }
`;
export const AContainer = styled.a<{ theme: Theme; margin: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${p => getWidthByType(p.theme)};
  height: 48px;
  border-radius: 8px;
  border: none;
  background-color: ${p => getBackgroundColorByType(p.theme)};
  color: ${p => getFontColorByType(p.theme)};
  ${p => getBorderByType(p.theme)}
  font-size: 16px;
  text-decoration: none;
  padding: ${p => getPaddingByType(p.theme)};
  transition: all 300ms ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const Icon = styled.img`
  margin-left: 10px;
  width: 20px;
`;

export const Text = styled.span`
  flex-grow: 1;
  text-align: center;
  margin-right: 30px;
`;
